// extracted by mini-css-extract-plugin
module.exports = {"csvImportInfo":"GenerateInvitationForm_csvImportInfo_pMt0v"};